import * as AppConstants from "AppConstants";
import { setGlobalAuthorizationHeader } from "app/services/auth.header.service";
import * as sessionStorageProxy from "app/services/app.session.storage.proxy";

/**
 * Clears all session state for the logged-in user and drops the global Authorization header.
 *
 * Lives in its own leaf module (depends only on storage/constants/header helpers) so it can be
 * called from the axios error handler on a 401 without pulling in auth.service — which would
 * create an import cycle (app.error.handler -> auth.service -> user.service -> app.error.handler).
 */
export const resetSessionStorage = () => {
    sessionStorageProxy.setItem(AppConstants.SESSION_KEY_IS_LOGIN, false); // Remove Authorization header from request
    sessionStorageProxy.setItem(AppConstants.SESSION_KEY_TOKEN, null);
    sessionStorageProxy.setItem(AppConstants.SESSION_KEY_LOGGED_IN_USER, null);
    sessionStorageProxy.setItem(AppConstants.SESSION_KEY_CURRENT_MEMBER, null);
    sessionStorageProxy.setItem(AppConstants.SESSION_KEY_CURRENT_CLIENT, null);
    sessionStorageProxy.setItem(AppConstants.SESSION_KEY_CURRENT_MANAGER, null);
    sessionStorageProxy.setItem(AppConstants.SESSION_KEY_MEMBER_CLIENTS, null);
    setGlobalAuthorizationHeader(null);
};

// Actions on logout
export const logout = () => {
    resetSessionStorage();
};
